
export default {
    CURD:{
        url: '/{modelname}',
        method: "post",
    }
}
